/** Update by hand when the Recruitee posting count changes (currently 7 live postings). */
export const OPEN_POSITIONS_COUNT = 7;
